import { useExperienceScreen } from '../screen/use-experience-screen';

export default ({
    experience = {}
} = {}) => {
    const { isCourseSelected, selectedCourses } = useExperienceScreen();
    const hasMultipleSelected = isCourseSelected(experience);
    
    return {
        hasMultipleSelected,
        selectedCourses
    }
}